<template>
  <div class="alarmCont">
    <div class="listheader">
      <div class="titleName">疑似飞房</div>
      <span>合计：{{ numTotal }}</span>
    </div>
    <div class="alarm_panel">
      <div v-if="sos" class="listcount">
        <template v-if="offlineStores.length">
          <div
            v-for="(item, index) in offlineStores"
            :key="index"
            class="list listHover"
          >
            <div class="hotelName">{{ showName(item.hname) }}</div>
            <span class="Num">{{ item.ffCnt }}</span>
          </div>
        </template>
        <template v-else>
          <div class="noData flex flex-center align-center">
            暂无 疑似飞房 数据
          </div>
        </template>
      </div>
      <div v-else class="storesDetails" @click="showAll">
        <div class="storesName" v-if="offlineName">
          {{ showName(offlineName) }}
        </div>
        <div class="detailsListCont">
          <!-- <img src="../../assets/loading.gif" alt="" v-if="showDataFlag"> -->
          <div v-if="!showDataFlag">
            <div v-for="(item, index) in roomList" :key="index">
              <!-- 2551 -->
              {{ item.floorName }}{{ item.roomNumber }}
              房
            </div>
          </div>
          <div
            v-if="!roomList || roomList.length == 0"
            class="noData2 flex flex-center align-center"
          >
            暂无 疑似飞房 数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GET_feifangList, GET_feifangRoom, GET_feifangRoom_jt } from "@/api";
import { showName } from "@/api/common";
export default {
  props: {
    roleType: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      offlineStores: [], //sos门店
      sos: true,
      showDataFlag: false,
      offlineName: "", //门店名
      roomList: [],
    };
  },
  computed: {
    numTotal() {
      if (this.roleType == 0) {
        return this.offlineStores.reduce(function (sum, item) {
          let val = item.ffCnt ? item.ffCnt : 0;
          return sum + val;
        }, 0);
      } else {
        return this.roomList.length;
      }
    },
  },
  created() {
    if (this.roleType == 0) {
      this.getlist();
      this.sosInter = null;
      this.sosInter = setInterval(() => {
        this.getlist();
      }, 5000);
    } else {
      this.sos = false;
      this.GET_Room_data();
      this.sosInter = null;
      this.sosInter = setInterval(() => {
        this.GET_Room_data();
      }, 5000);
    }
  },
  beforeDestroy() {
    clearInterval(this.sosInter);
  },
  methods: {
    showAll() {
      if (this.roleType == 0) {
        this.sos = true;
      }
    },
    async GET_Room_data() {
      try {
        let res = await GET_feifangRoom_jt();
        if (res.code == "000000") {
          this.roomList = res.data.data;
          if (this.roomList.length) {
            this.offlineName = this.roomList[0].hotelName;
          }
        }
      } catch (error) {}
    },
    showName(val) {
      // if (this.$route.meta.title == "万润看板") return val;
      // else
      return showName(val);
    },
    //sos报警门店
    async getlist(data = { roleType: this.roleType }) {
      let res = await GET_feifangList(data);

      this.offlineStores = res.data.data;
    },
    // 点击报警门店事件
    offlineClick(item) {
      this.sos = false;
      this.showDataFlag = true;
      this.offlineName = item.hotelName;
      this.getRoom(item);
    },

    //sos报警房间
    async getRoom(data) {
      let res = await GET_feifangRoom(data);
      this.roomList = res.data.data;
      this.showDataFlag = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/mdKanban/index.scss";
@import "@/assets/mdKanban/listData.scss";
</style>
